import gql from 'graphql-tag'

export const customerLocationFragment = gql`
    fragment customerLocationFragment on CustomerLocation{
        id
        deleted_at
        name
        label
        street
        town
        state
        country
        zipcode
        primary_phone
        secondary_phone
        fax
        website
        email
        note
    }
`